var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.509 7.91665C32.3382 10.8734 33.9214 14.8545 33.9166 19C33.9191 21.077 33.5225 23.1341 32.7495 25.0534C31.9764 26.9726 30.8422 28.7164 29.4118 30.1846M7.70827 30.3082C6.24172 28.8355 5.07698 27.0763 4.28267 25.1343C3.48837 23.1922 3.08055 21.1064 3.08327 19C3.08076 16.9177 3.4794 14.8555 4.25623 12.9321C5.03307 11.0088 6.17273 9.26223 7.6096 7.79315M25.106 12.7363C26.7401 14.3434 27.7499 16.5442 27.7499 18.9715C27.7499 21.4288 26.717 23.6534 25.0474 25.2637M12.0249 25.3333C10.3137 23.7167 9.24993 21.4637 9.24993 18.9715C9.24993 16.5094 10.2875 14.2785 11.9663 12.6667",
    stroke: "#383838",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0528 16.5474C22.4342 17.5908 23.1248 18.1101 23.1248 19C23.1248 19.8898 22.4342 20.4107 21.0528 21.4525C20.6925 21.7264 20.3233 21.9878 19.9459 22.2363C19.6166 22.4477 19.2808 22.6483 18.9392 22.838C17.561 23.6138 16.8734 24.0017 16.2552 23.5726C15.637 23.1435 15.5815 22.2458 15.4689 20.4519C15.4381 19.9436 15.4165 19.4465 15.4165 19C15.4165 18.5535 15.4365 18.0563 15.4689 17.548C15.5799 15.7541 15.637 14.8564 16.2552 14.4289C16.8718 13.9982 17.561 14.3861 18.9377 15.1604C19.2969 15.3615 19.6422 15.5657 19.9459 15.7636C20.2943 15.99 20.672 16.2608 21.0528 16.5474Z",
    stroke: "#383838",
    strokeWidth: 1.875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.9fb13cb14a020e20d7820b92d10d9bf1.svg";
export { ForwardRef as ReactComponent };